import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  buttonDiscart: {
    outline: '1px solid #be1224 !important',
    color: '#be1224'
  },
  buttonContainer: {
    gap: '1rem'
  },
  button: {
    backgroundColor: '#159B78',
    color: 'white',
    flexGrow: 1
  },
  buttonApply: {
    outline: '1px solid #159B78 !important',
    color: '#159B78',
    flexGrow: 1
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}));
